import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";
import { useAppSelector as useSelector } from "../../../store";
import CustomButton from "../../UI/Buttons/CustomButton";
import RoundedPlus from "../../UI/Icons/RoundedPlus";
import { useEffect, useState } from "react";

const TabsHeader = ({
  activeHeader = "Active",
}: {
  activeHeader: "Active" | "History";
}) => {
  const navigate = useNavigate();

  const { totalPendingVacancies, totalAcceptedVacancies } = useSelector(
    (state) => state.vacancy.active
  );

  const handleVacancyActive = () => {
    navigate(AUTH_ROUTE.CLIENT_VACANCIES);
  };

  const handleVacancyHistory = () => {
    navigate(AUTH_ROUTE.VACANCY_HISTORY);
  };

  const handleCreateVacancy = () => {
    navigate(AUTH_ROUTE.CREATE_VACANCY);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 991);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 991);
    }

    window.addEventListener("resize", handleResize);

    // Clean up listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="d-flex flex-column gap-10">
        <div className="d-flex flex-column">
          <div className="d-flex gap-20 justify-content-between overflow-auto mobile-scroll-hide">
            <div className="d-flex gap-10 text-nowrap">
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px ${
                  isMobile ? "py-13px" : "py-5px"
                } cursor-pointer ${
                  activeHeader === "Active"
                    ? "bg-black text-white"
                    : "bg-off-white text-black"
                }`}
                onClick={handleVacancyActive}
              >
                <span className="fw-700">
                  {totalPendingVacancies + totalAcceptedVacancies}
                </span>{" "}
                Active Vacancies
              </div>
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px ${
                  isMobile ? "py-13px" : "py-5px"
                } cursor-pointer ${
                  activeHeader === "History"
                    ? "bg-black text-white"
                    : "bg-off-white text-black"
                }`}
                onClick={handleVacancyHistory}
              >
                History
              </div>
            </div>
            <div className="d-none d-lg-block pb-5px">
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-teal text-black text-nowrap"
                onClick={handleCreateVacancy}
              >
                <RoundedPlus
                  className="min-w-20px"
                  width={20}
                  height={20}
                  fill="black"
                />
                Create a Vacancy
              </CustomButton>
            </div>
          </div>
          <div className="bg-black w-100 h-5px"></div>
        </div>
        <div className="d-block d-lg-none text-center">
          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-teal text-black text-nowrap"
            onClick={handleCreateVacancy}
          >
            <RoundedPlus
              className="min-w-20px"
              width={20}
              height={20}
              fill="black"
            />
            Create a Vacancy
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default TabsHeader;
